// extracted by mini-css-extract-plugin
export default {"formHeading":"NE-z","form":"OE-z","submitBtn":"PE-z","disabled":"QE-z","input":"RE-z","error":"SE-z","submitMsg":"TE-z","signIn":"UE-z"};